import { v4 as uuidv4 } from 'uuid';
import DocumentStoreApiClient from '../api/clients/DocumentStoreApiClient';

export default class DocumentStoreRepository {
  constructor(url, storageKey, token = '') {
    this.storageKey = storageKey;
    this.apiClient = new DocumentStoreApiClient(url, token);
  }

  async set(data) {
    let stringData = JSON.stringify(data);
    localStorage.setItem(this.storageKey, stringData);
  }

  async getAll() {
    let documentData = [];

    documentData = JSON.parse(localStorage.getItem(this.storageKey));
    documentData = documentData ? documentData : [];

    return documentData;
  }

  async getById(dataList, dataId) {
    return dataList.find(x => x.id === dataId);
  }

  async add(dataList, data) {
    let dataGuuid = uuidv4();
    dataGuuid = dataGuuid.replace(/-/g, '');

    try {
      let dataToAdd = {
        ...data,
        id: dataGuuid,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      // add element at the top of the array
      dataList.unshift(dataToAdd);

      await this.set(dataList);

      return dataList;
    } catch {
      throw new Error('Error adding the item');
    }
  }

  async update(dataList, data) {
    try {
      let foundIndex = dataList.findIndex(x => x.id === data.id);
      dataList[foundIndex] = data;

      await this.set(dataList);

      return dataList;
    } catch {
      throw new Error('Error on update the item');
    }
  }
}
